import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Post = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7784 8.45187C14.953 8.36916 15.0643 8.19323 15.0643 8.00001C15.0643 7.80678 14.953 7.63085 14.7784 7.54814L3.26265 2.09331C3.08163 2.00757 2.86691 2.03812 2.717 2.17096C2.56709 2.3038 2.51092 2.51328 2.57426 2.7033L4.33983 8.00001L2.57426 13.2967C2.51092 13.4867 2.56709 13.6962 2.717 13.8291C2.86691 13.9619 3.08163 13.9924 3.26265 13.9067L14.7784 8.45187ZM5.22726 7.5L3.89347 3.49864L13.3964 8.00001L3.89347 12.5014L5.22726 8.5H8.50004C8.77618 8.5 9.00004 8.27614 9.00004 8C9.00004 7.72386 8.77618 7.5 8.50004 7.5H5.22726Z"
        fill={color}
      />
    </svg>
  )
})

export default Post
